import api from '@/services/api';
import { Post } from '@/types/post';
import { PaginatedResponse } from '@/types/common';
import { Trend, Article, TrendDetail } from '@/types/trend';

export const trendService = {
  async getAll(): Promise<PaginatedResponse<Trend>> {
    const response = await api.get<PaginatedResponse<Trend>>('/trends?offset=0&limit=1000');
    return response.data;
  },

  async getById(id: string): Promise<TrendDetail> {
    const response = await api.get<TrendDetail>(`/trends/${id}`);
    return response.data;
  },

  async getPosts(trendId: string): Promise<PaginatedResponse<Post>> {
    const response = await api.get<PaginatedResponse<Post>>(`/posts/${trendId}`);
    return response.data;
  },

  async getArticles(trendId: string): Promise<PaginatedResponse<Article>> {
    const response = await api.get<PaginatedResponse<Article>>(`/articles/${trendId}`);
    return response.data;
  }
};